import { Center, Text } from '@chakra-ui/react'

const AppFooter = () => {
	return (
		<Center h={'40px'}>
			<Text fontSize={'16px'}>
				&copy; {new Date().getFullYear()} {process.env.REACT_APP_NAME}. All rights reserved
			</Text>
		</Center>
	)
}

export default AppFooter
